module.exports = __webpack_public_path__ + "static/media/1.5e2bd531.jpg";